// extracted by mini-css-extract-plugin
export default {"consultationContainer":"Step_Consultation_consultationContainer__mRdC2","form":"Step_Consultation_form__nMygA"};